// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1eUiP","footer":"ModalInfo_footer__1bKjM"};